// extracted by mini-css-extract-plugin
module.exports = {"tinyWidget":"TinyWidget_tinyWidget__8pKGi","disabled":"TinyWidget_disabled__20srO"};